module.exports = __webpack_public_path__ + "img/aave.fc27527f.svg";